import {BalanceTillSummaryReportModel} from "./balance-till-summary-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-balance-till-summary-report",
    templateUrl: "./balance-till-summary-report.component.html",
    providers: [provideReportModel(BalanceTillSummaryReportModel)]
})
export class BalanceTillSummaryReportComponent extends AbstractReportPage {
    constructor(public model: BalanceTillSummaryReportModel) {
        super();
    }
}
